import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import CollectFeePage from "./CollectFeePage";

export default {
  list: CollectFeePage,
  icon: PointOfSaleIcon,
  label: "Collect fee",
  options: { label: "Collect fee" },
  name: "feeCollect",
};
